import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import ActionButton from '@/components/Button/ActionButton';
import { DataTable, DataTablePagination } from '@/components/DataTable';
import { FillScreen, HStack } from '@/components/Layout';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { SearchSchema } from './-constants';
import { useOutboundTable } from './-hooks/useTable';
export const Route = createFileRoute('/_staff/settings/data-connector/outbound/data-pipeline/_list/')({
  validateSearch: zodValidator(SearchSchema),
  component: OutboundDataPipelineListPage
});

/** OUT 一覧。IN `InboundDataPipelineListPage` と同型のテーブル + ページネーション。 */
function OutboundDataPipelineListPage() {
  const navigate = useNavigate();
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.dataConnector.outboundDataPipeline'
  });
  const {
    table,
    displayState,
    count
  } = useOutboundTable();
  return <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <HStack className="items-center">
        <span className="ml-auto">
          <ActionButton icon="PlusIcon" onClick={() => navigate({
          to: '/settings/data-connector/outbound/data-pipeline/add'
        })}>
            {t('addPipeline')}
          </ActionButton>
        </span>
      </HStack>
      <div className="min-h-0 flex-1 overflow-auto">
        <DataTable table={table} displayState={displayState} onRowClick={row => {
        navigate({
          to: '/settings/data-connector/outbound/data-pipeline/$id/execution-results',
          params: {
            id: row.original.id
          }
        });
      }} />
      </div>
      <DataTablePagination table={table} totalCount={count} />
    </FillScreen>;
}